/**
 * @param {{tone?: "neutral"|"gain"|"loss"|"warn"|"info", children: React.ReactNode}} props
 */
export default function Chip({ tone = 'neutral', children }) {
  const cls = `aq-chip ${tone !== 'neutral' ? `aq-chip--${tone}` : ''}`.trim();
  return <span className={cls}>{children}</span>;
}
